export default __webpack_public_path__ + "static/media/uifaces-avatar.ae4bb7ca.jpg";